export const urls = {
    page: {
      home: '/',
      login: '/login',
      setPassword: '/establecer-contrasena'
    },
    app: {
      index: 'app',
      main: {
        third: {
          form: 'third/form',
          thirdMigrationForm: 'third/migration/form',
          list: 'third/list'
        },
        electronicBill: {
          form: 'electronic-bill/form',
          list: 'electronic-bill/list',
          schedule_list: 'electronic-bill/schedule/list',
          credit_note_list: 'electronic-bill/credit-note/list'
        },
        supportDocument: {
          form: 'support-document/form',
          list: 'support-document/list',
          credit_note_list: 'support-document/credit-note/list'
        },
        item: {
          form: 'item/form',
          list: 'item/list'
        }
      }
    }
}
